import { Navigate, Outlet } from 'react-router';
import { useAuthService } from '@/providers/auth-service-provider';
import { PATHS } from '@/routes/paths';

export function RequireAuthLayout(): React.ReactElement {
  const { isAuthenticated } = useAuthService();
  if (!isAuthenticated) {
    return <Navigate to={PATHS.signIn} replace />;
  }
  return <Outlet />;
}
